import { Environment } from './environment.interface';

/**
 * Default development environment configuration
 * Used when running `ng serve` or `npm start`
 */
export const environment: Environment = {
  name: 'development',
  production: false,

  api: {
    baseUrl: 'https://dev.apps.manulife.co.jp/ext/dev2/eclaims/api/v1/'
    //  baseUrl: 'https://sit.apps.manulife.co.jp/ext/eclaims/api/v1/'
  },
  session: {
    timeoutMinutes: 60,        // 5 minutes for dev
    warningMinutes: 2         // 1 minute warning for dev
  },
  app: {
    version: '1.0.0-dev',
    name: 'JPES eClaims',
    defaultLanguage: 'ja',
    supportedLanguages: ['ja', 'en'],
    appUrl: 'https://dev.e-seikyu.manulife.co.jp/#/eclaim',
    newRelicUrl: '/assets/newRelic/JPES-ECLAIMS-DEV.js',
    adobeAnalyticsUrl: 'https://assets.adobedtm.com/b84dbf01908c/ea9ea5ad8be8/launch-b7a8bf727ff2-staging.min.js'
  }
};